<ng-template #contentHeaderTemplate></ng-template>

@if (patient?.id) {
  <app-tab-switcher
    [config]="[
    {link: '/patients/' + this.patient!.id, translationKey: 'authenticated.patients.edit.tabs.details', exact: true},
    {link: '/patients/' + this.patient!.id + '/documents', translationKey: 'authenticated.patients.edit.tabs.documents', exact: true},
    {link: '/patients/' + this.patient!.id + '/emails', translationKey: 'authenticated.patients.edit.tabs.emails', exact: false},
    {link: '/patients/' + this.patient!.id + '/history', translationKey: 'authenticated.patients.edit.tabs.history', exact: false},
  ]"
  ></app-tab-switcher>

  <div class="pb-2">
    <div class="card">
      <div class="card-body">
        <app-table
          id="dashboard.patients.authentication-audit-log.index"
          [replaceParametersInUrl]="{'{patient}': patient!.id}"
          [showEditLink]="false"
          [showTopRow]="false"
          [showBorder]="false"
        ></app-table>
      </div>
    </div>
  </div>
}
